<div class="page">
    <div class="title">
        <button class="buttonBack" (click)="irAUrlAnterior()"><mat-icon>arrow_back</mat-icon></button>
        <div class="titleValue">{{ 'termsAndConditions.title' | transloco }}</div>
        <div class="line"></div>
    </div>

    <div class="content">
        <p [innerHTML]="'termsAndConditions.intro.p1' | transloco"></p>

        <h3>{{ 'termsAndConditions.userResponsibility.title' | transloco }}</h3>
        <p>{{ 'termsAndConditions.userResponsibility.p1' | transloco }}</p>
        <p>{{ 'termsAndConditions.userResponsibility.p2' | transloco }}</p>
        <ul>
            <li *ngFor="let item of 'termsAndConditions.userResponsibility.list' | transloco">{{ item }}</li>
        </ul>

        <h3>{{ 'termsAndConditions.linksPolicy.title' | transloco }}</h3>
        <p>{{ 'termsAndConditions.linksPolicy.p1' | transloco }}</p>
        <p>{{ 'termsAndConditions.linksPolicy.p2' | transloco }}</p>

        <h3>{{ 'termsAndConditions.modifications.title' | transloco }}</h3>
        <p>{{ 'termsAndConditions.modifications.p1' | transloco }}</p>

        <h3>{{ 'termsAndConditions.dataProtection.title' | transloco }}</h3>
        <p>{{ 'termsAndConditions.dataProtection.p1' | transloco }}</p>
        <p>{{ 'termsAndConditions.dataProtection.p2' | transloco }}</p>
        <p>{{ 'termsAndConditions.dataProtection.p3' | transloco }}</p>
        <p>{{ 'termsAndConditions.dataProtection.p4' | transloco }}</p>
        <p>{{ 'termsAndConditions.dataProtection.p5' | transloco }}</p>

        <h3>{{ 'termsAndConditions.intellectualProperty.title' | transloco }}</h3>
        <p>{{ 'termsAndConditions.intellectualProperty.p1' | transloco }}</p>
        <p>{{ 'termsAndConditions.intellectualProperty.p2' | transloco }}</p>

        <h3>{{ 'termsAndConditions.legalActions.title' | transloco }}</h3>
        <p>{{ 'termsAndConditions.legalActions.p1' | transloco }}</p>
        <p>{{ 'termsAndConditions.legalActions.p2' | transloco }}</p>
    </div>
</div>
